import React from "react";
import css from "./card.module.scss";
import {
  IconStar,
  IconNoStar,
  IconWave,
} from "../../re_redesigned_componnents/icon/index";

function NotificationCard({
  updateNotification,
  currentElement,
  type,
  content,
  time,
  fav = false,
  read = false,
  onChange,
  index,
  goto = () => {},
}) {
  return (
    <div
      className={css.cardWrap}
      style={{ backgroundColor: !read ? "white" : "#D9D9D9" }}
    >
      <div className={css.type}>{type}</div>
      <div
        onClick={() => {
          onChange(index, "read", true);
          goto(true, currentElement);
          updateNotification(
            currentElement.entity_id,
            currentElement.type_id,
            true,
            fav
          );
        }}
        className={css.content}
      >
        {content}
      </div>
      <div className={css.fav}>
        <button
          onClick={() => {
            onChange(index, "favourite", !fav);
            updateNotification(
              currentElement.entity_id,
              currentElement.type_id,
              true,
              !fav
            );
          }}
        >
          {fav ? <IconStar /> : <IconNoStar />}
        </button>
      </div>
      <div className={css.time}>{time}</div>

      <div className={css.read}>
        <div
          style={{ backgroundColor: read ? "red" : "green" }}
          className={css.dot}
        ></div>
      </div>
    </div>
  );
}

export default NotificationCard;
